import { render } from "./HearthIcon.vue?vue&type=template&id=34f70170&scoped=true"
import script from "./HearthIcon.vue?vue&type=script&lang=js"
export * from "./HearthIcon.vue?vue&type=script&lang=js"

import "./HearthIcon.vue?vue&type=style&index=0&id=34f70170&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f70170"]])

export default __exports__